/* eslint-disable */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRolesPermissions } from '../pages/rolespermissions/RolesPermissionsContext';
import Loader from '../utils/errorPages/Loader';
const ProtectedRoute = ({ module, permission, element }) => {
  // eslint-disable-next-line camelcase
  const { modules, permissions, isAuthenticated, loading } = useRolesPermissions();

  const hasPermission = () => {
    if (loading) {
      return false; // Loading state, no permissions yet
    }
    // Check if modules and permissions are defined
    if (!modules || !permissions) {
      return false;
    }
    // eslint-disable-next-line camelcase
    if (isAuthenticated) {
      return true; // Admin has all permissions
    }
    if (!modules.includes(module)) {
      return false;
    }
    if (!permissions[module] || !permissions[module].includes(permission)) {
      return false;
    }
    return true;
  };

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    ); // Render loading state
  }

  // return hasPermission() ? (element ? element : <Outlet />) : <Navigate to="/dashboard" />;

  return hasPermission() ? element : <Navigate to="/dashboard" />;
};

export default ProtectedRoute;
